import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import axios from "./../../../axios";

import "./SubscriptionComponent.css";

export default function SubscriptionComponent() {
  const [currentPlan, setCurrentPlan] = useState(null);
  const [pastPlans, setPastPlans] = useState([]);

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([axios.get("/v1/tutor/current-subscription"), axios.get("/v1/tutor/expired-subscriptions")])
      .then(async ([currentSubscriptionApiResponse, expiredSubscriptionsApiResponse]) => {
        const current = currentSubscriptionApiResponse.data;
        console.log("🚀 ~ SubscriptionComponent ~ current:", current);
        const past = expiredSubscriptionsApiResponse.data;

        if (current?.is_success && current?.data) {
          setCurrentPlan(current.data);
        }
        if (past?.is_success && past?.data) {
          setPastPlans(past.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Subscription fetch error:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="subscription-loader">Loading subscriptions...</div>;
  }

  return (
    <div className="subscription-wrapper">
      {/* ❌ No Current Plan: Show Subscribe Now banner */}
      {!currentPlan && (
        <div className="no-plan-banner">
          <span className="subscribe-plan-text">
            <strong>NOTE:</strong> You haven’t subscribed to any plan, Click on <strong>“Subscribe Now”</strong> to
            become a verified tutor
          </span>
          <button
            className="subscribe-now-btn"
            onClick={() => navigate("/verify-account")} // 👈 Redirect to plan purchase page
          >
            Subscribe Now
          </button>
        </div>
      )}

      {/* ✅ Current Subscription : Basic Plan */}
      {currentPlan && currentPlan?.plan?.id === 1 && (
        <div className="current-plan-container">
          <div className="current-subscription-box">
            <div className="subscription-header">
              <span className="label-bold">Current Plan:</span>
              <span className="subscription-date">Expires On: {currentPlan.expiry_at?.split("T")[0] ?? "N/A"}</span>
            </div>

            <div className={`current-plan-box`}>
              <div className="plan-label basic-label">Basic Plan</div>
              <div className="plan-price">
                ₹ <span>499</span>/-
              </div>
              <div className="plan-gst">* Exclusive of GST.</div>
              <ul className="plan-features">
                <li className="check">MoneyBack Guarantee</li>
                <li className="check">Get multiple high paying tuition opportunities</li>
                <li className="check">Subscription Validity: 12 months</li>
                <li className="check">Receive daily Whatsapp & In App notifications</li>
                <li className="cross">VIP/VVIP client access</li>
                <li className="cross">Experience certificate</li>
                <li className="cross">Rank higher among other tutors</li>
                <li className="cross">Recommendation letter</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {currentPlan && currentPlan?.plan?.id === 5 && (
        <div className="plan-selection-container">
          {/* ✅ Current Subscription : Basic Plan */}
          <div className="current-subscription-box">
            <div className="subscription-header">
              <span className="label-bold">Current Plan:</span>
              <span className="subscription-date">Expires On: {currentPlan.expiry_at?.split("T")[0] ?? "N/A"}</span>
            </div>

            <div className={`current-plan-box selected-plan premium-border`}>
              <div className="plan-label premium-label">Premium Plan</div>
              <div className="plan-price" style={{ color: "#F2C00C" }}>
                ₹ <span>999</span>/-
              </div>
              <div className="plan-gst">* Exclusive of GST.</div>
              <ul className="plan-features">
                <li className="check">MoneyBack Guarantee</li>
                <li className="check">Get multiple high paying tuition opportunities</li>
                <li className="check">Subscription Validity: Lifetime</li>
                <li className="check">Receive daily Whatsapp & In App notifications</li>
                <li className="check">VIP/VVIP client access</li>
                <li className="check">Experience certificate</li>
                <li className="check">Rank higher among other tutors</li>
                <li className="check">Recommendation letter</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      <hr className="subscription-divider" />

      {/* ✅ Past Subscriptions */}
      {pastPlans.length > 0 ? (
        <>
          <div className="past-subscriptions">
            <div className="past-subscriptions-header">Past Subscriptions :</div>
            <div className="past-subscriptions-grid">
              {pastPlans.map((sub, index) => (
                <div className="past-subscription-card" key={index}>
                  <div className="plan-title">
                    {`HomeShiksha ${sub?.plan?.id === 5 ? "Premium Plan" : "Basic Plan"} `}
                    <span className="expired-tag">EXPIRED</span>
                  </div>
                  <div className="plan-date">Subscribed on: {sub.start_date.split("T")[0]}</div>
                  <div>
                    {`${sub?.plan?.id === 5 ? "12 months: " : "6 months: "}`}₹{sub.plan.amount}/-
                  </div>
                  <div className="plan-expired-date">Expired on: {sub.end_date?.split("T")[0] ?? "N/A"}</div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="past-subscriptions">
            <div className="past-subscriptions-header">
              Past Subscriptions :{" "}
              <span className="past-subscriptions-sub-header">You don't have any past subscriptions</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
